/* eslint-disable no-unused-vars */
import { TourBagHistoryModel } from '@/api/models';
import dayjs from 'dayjs';

export type HistoryFieldNames =
  | 'Model'
  | 'Serial'
  | 'In Bag'
  | 'Family'
  | 'Family Note'
  | 'Hand'
  | 'Level'
  | 'Type'
  | 'Finish'
  | 'Finish Note'
  | 'Sightline'
  | 'Face'
  | 'Neck'
  | 'Iron Club'
  | 'Loft'
  | 'Lie'
  | 'Msrd. Loft'
  | 'Fwd/Toe Wt. #'
  | 'Fwd/Toe Wt. Loc.'
  | 'Aft/Heel Wt. #'
  | 'Aft/Heel Wt. Loc.'
  | 'CT'
  | 'CT Loc.'
  | 'Swing Wt.'
  | 'Sole Wts.'
  | 'Overall Wt.'
  | 'Back Wt'
  | 'Final HW'
  | 'Hot Melt'
  | 'Hot Melt 1'
  | 'Hot Melt 2'
  | 'Hot Melt 3'
  | 'Hot Melt 4'
  | 'Hot Melt 5'
  | 'Hot Melt 6'
  | 'Hot Melt 7'
  | 'Stamping'
  | 'Painting'
  | 'Grind Details'
  | 'Shaft'
  | 'Putter Shaft'
  | 'Length'
  | 'Measured'
  | 'Tipping'
  | 'Setting'
  | 'Sleeve'
  | 'Cosmetic'
  | 'Round/Rib'
  | 'Logo'
  | 'Grip'
  | 'Grip Size'
  | 'Grip Tape'
  | 'Ball'
  | 'Ball Note'
  | 'Glove'
  | 'Glove Size'
  | 'Glove Note'
  | 'Headwear'
  | 'Headwear Note'
  | 'Shoe'
  | 'Size'
  | 'Width'
  | 'Golf Bag'
  | 'Bag Note'
  | 'Name on Bag'
  | 'Bag Logo'
  | 'Bag Logo 1'
  | 'Bag Logo 2'
  | 'Bag Logo 3'
  | 'Notes'
  | '';

//Driver: 1,
//Fairway: 2,
//Hybrid: 3,
//Iron: 4,
//Wedge: 5,
//Putter: 6,
//Utility: 7,
// BSG does not have a headTypeId, so we set 0

export const HistoryFieldClubTypes: Record<HistoryFieldNames, number[]> = {
  Model: [1, 2, 3, 4, 5, 6, 7],
  Serial: [1, 2, 3],
  'In Bag': [1, 2, 3, 4, 5, 6, 7],
  Family: [1, 2, 3, 4, 5, 7],
  'Family Note': [5],
  Hand: [1, 2, 3, 4, 5, 6, 7],
  Level: [6],
  Type: [6],
  Finish: [5, 6],
  'Finish Note': [5],
  Sightline: [6],
  Face: [6],
  Neck: [6],
  'Iron Club': [4, 7],
  Loft: [1, 2, 3, 4, 5, 6, 7],
  Lie: [4, 5, 6, 7],
  'Msrd. Loft': [1, 2, 3],
  'Fwd/Toe Wt. #': [1, 2, 3],
  'Fwd/Toe Wt. Loc.': [1, 2, 3],
  'Aft/Heel Wt. #': [1, 2],
  'Aft/Heel Wt. Loc.': [1, 2],
  CT: [1],
  'CT Loc.': [1],
  'Swing Wt.': [1, 2, 3, 4, 5, 6, 7],
  'Sole Wts.': [6],
  'Back Wt': [4, 7],
  'Final HW': [1, 2, 3, 4, 5, 7],
  'Hot Melt': [1, 2, 3],
  'Hot Melt 1': [1, 2, 3],
  'Hot Melt 2': [1, 2, 3],
  'Hot Melt 3': [1, 2, 3],
  'Hot Melt 4': [1, 2, 3],
  'Hot Melt 5': [1, 2, 3],
  'Hot Melt 6': [1, 2, 3],
  'Hot Melt 7': [1, 2, 3],
  Stamping: [5, 6],
  Painting: [6],
  'Overall Wt.': [6],
  'Grind Details': [5],
  Shaft: [1, 2, 3, 4, 5, 7],
  'Putter Shaft': [6],
  Measured: [1, 2, 3, 4, 5, 6, 7],
  Length: [1, 2, 3, 4, 5, 6, 7],
  Tipping: [1, 2, 3, 4, 7],
  Setting: [1, 2, 3],
  Sleeve: [1, 2, 3],
  Cosmetic: [1, 2, 3, 4, 5, 7],
  Grip: [1, 2, 3, 4, 5, 6, 7],
  'Grip Size': [1, 2, 3, 4, 5, 7],
  'Round/Rib': [1, 2, 3, 4, 5, 7],
  Logo: [1, 2, 3, 4, 5, 7],
  'Grip Tape': [1, 2, 3, 4, 5, 6, 7],
  Ball: [0],
  'Ball Note': [0],
  Glove: [0],
  'Glove Size': [0],
  'Glove Note': [0],
  Headwear: [0],
  'Headwear Note': [0],
  Shoe: [0],
  Size: [0],
  Width: [0],
  'Golf Bag': [0],
  'Bag Note': [0],
  'Name on Bag': [0],
  'Bag Logo': [0],
  'Bag Logo 1': [0],
  'Bag Logo 2': [0],
  'Bag Logo 3': [0],
  Notes: [0, 1, 2, 3, 4, 5, 6, 7],
  '': [],
};

export class HistoryRow {
  constructor(
    public modifyUserName = '',
    public date = '',
    public diffs = [] as HistoryRowDetail[],
  ) {}
}

export class HistoryRowDetail {
  constructor(
    public fieldName: HistoryFieldNames = '',
    public current = '',
    public previous: string | null = null,
  ) {}
}

//get a list of all rows that had changes to at least on of the fields.
//option to not sort by date b/c when this is running off line, the local browser date/time can be out of sync with the server. So just use them in the order passed
export const getHistoryRows = (rowGuid: string, headTypeId: number, historyRecords: TourBagHistoryModel[], enableDateSort = true) => {
  //match on the rowGuid, except for BSG which doesn't use rowGuid to track history, so get all records
  let clubHistoryRecords = historyRecords.filter((h) => h.rowGuid == rowGuid || headTypeId == 0);
  if (enableDateSort) {
    clubHistoryRecords.sort((a, b) => b.modifyDate.toString().localeCompare(a.modifyDate.toString()));
  }
  let historyRows = [] as HistoryRow[];
  if (clubHistoryRecords.length > 1) {
    //need to sort by id depending on club type
    let historyRow: HistoryRow | null = null;
    for (var rowIx = 0; rowIx < clubHistoryRecords.length - 1; rowIx++) {
      historyRow = getHistoryRow(headTypeId, clubHistoryRecords[rowIx], clubHistoryRecords[rowIx + 1]);
      //if there were diffs, save it to the collection of all diffs
      if (historyRow) {
        historyRows.push(historyRow);
      }
    }
  }
  //special case: The last row in the history is the first created. Thus, there will be no 'previous' row. Pass null so that special logic is applied
  if (clubHistoryRecords.length >= 1) {
    let historyRow = getHistoryRow(headTypeId, clubHistoryRecords[clubHistoryRecords.length - 1], null);
    if (historyRow) {
      historyRows.push(historyRow);
    }
  }
  return historyRows;
};

//Find which fields have changed for the current row and create a collection of just the diff fields.
//If no fields had changes, then this won't be added to the history.
const getHistoryRow = (headTypeId: number, current: TourBagHistoryModel, previous: TourBagHistoryModel | null) => {
  //get the fields for the headTypeId
  let historyFields = [] as HistoryFieldNames[];
  Object.entries(HistoryFieldClubTypes).forEach(([key, value]) => {
    if (value.includes(headTypeId)) {
      historyFields.push(key as HistoryFieldNames);
    }
  });

  //build a collection of all the fields that have changed
  let historyRowDetails = [] as HistoryRowDetail[];

  let historyRow: HistoryRow | null = null;

  let historyRowDetail: HistoryRowDetail | null = null;
  historyFields.forEach((field) => {
    //reset the detail record to check for the next field
    historyRowDetail = null;
    switch (field) {
      case 'Model':
        if (toString(current.headModelName) != toString(previous?.headModelName)) {
          historyRowDetail = new HistoryRowDetail(field, current.headModelName, toString(previous?.headModelName));
        }
        break;
      case 'In Bag':
        if (current.isActive != previous?.isActive) {
          historyRowDetail = new HistoryRowDetail(field, toString(current.isActive), toString(previous?.isActive));
        }
        break;
      case 'Family':
        if (toString(current.familyName) != toString(previous?.familyName)) {
          historyRowDetail = new HistoryRowDetail(field, current.familyName, toString(previous?.familyName));
        }
        break;
      case 'Serial':
        if (toString(current.laserNo) != toString(previous?.laserNo)) {
          historyRowDetail = new HistoryRowDetail(field, current.laserNo, toString(previous?.laserNo));
        }
        break;
      case 'Family Note':
        if (toString(current.familyNote) != toString(previous?.familyNote)) {
          historyRowDetail = new HistoryRowDetail(field, current.familyNote, toString(previous?.familyNote));
        }
        break;
      case 'Hand':
        if (toString(current.hand) != toString(previous?.hand)) {
          historyRowDetail = new HistoryRowDetail(field, current.hand, toString(previous?.hand));
        }
        break;
      case 'Iron Club':
        if (toString(current.ironClubName) != toString(previous?.ironClubName)) {
          historyRowDetail = new HistoryRowDetail(field, current.ironClubName, toString(previous?.ironClubName));
        }
        break;
      case 'Loft': {
        let currentLoft = toString(current.loftDigit) + toString(current.loftFraction);
        let previousLoft = toString(previous?.loftDigit) + toString(previous?.loftFraction);
        if (currentLoft !== previousLoft) {
          historyRowDetail = new HistoryRowDetail(field, currentLoft.trim(), previousLoft.trim());
        } else {
          // if loftDigit isn't being used, check loftName
          currentLoft = toString(current.loftName);
          previousLoft = toString(previous?.loftName);
          if (currentLoft !== previousLoft) {
            historyRowDetail = new HistoryRowDetail(field, currentLoft.trim(), previousLoft.trim());
          }
        }
        break;
      }
      case 'Lie': {
        let currentLie = toString(current.lieDigit) + toString(current.lieFraction);
        let previousLie = toString(previous?.lieDigit) + toString(previous?.lieFraction);
        if (currentLie !== previousLie) {
          historyRowDetail = new HistoryRowDetail(field, currentLie.trim(), previousLie.trim());
        }
        break;
      }
      case 'Msrd. Loft':
        if (current.measuredLoft != previous?.measuredLoft) {
          historyRowDetail = new HistoryRowDetail(field, toString(current.measuredLoft), toString(previous?.measuredLoft));
        }
        break;
      case 'Fwd/Toe Wt. #':
        if (toString(current.headWeightNumberLookupName) != toString(previous?.headWeightNumberLookupName)) {
          historyRowDetail = new HistoryRowDetail(field, current.headWeightNumberLookupName, previous?.headWeightNumberLookupName);
        }
        break;
      case 'Fwd/Toe Wt. Loc.':
        if (toString(current.headWeightLocationLookupName) != toString(previous?.headWeightLocationLookupName)) {
          historyRowDetail = new HistoryRowDetail(field, current.headWeightLocationLookupName, previous?.headWeightLocationLookupName);
        }
        break;
      case 'Back Wt':
        if (toString(current.headWeightNumberBackLookupName) != toString(previous?.headWeightNumberBackLookupName)) {
          historyRowDetail = new HistoryRowDetail(field, current.headWeightNumberBackLookupName, previous?.headWeightNumberBackLookupName);
        }
        break;
      case 'Aft/Heel Wt. #':
        if (toString(current.headWeightNumberAftLookupName) != toString(previous?.headWeightNumberAftLookupName)) {
          historyRowDetail = new HistoryRowDetail(field, current.headWeightNumberAftLookupName, previous?.headWeightNumberAftLookupName);
        }
        break;
      case 'Aft/Heel Wt. Loc.':
        if (toString(current.headWeightLocationAftLookupName) != toString(previous?.headWeightLocationAftLookupName)) {
          historyRowDetail = new HistoryRowDetail(field, current.headWeightLocationAftLookupName, previous?.headWeightLocationAftLookupName);
        }
        break;
      case 'CT':
        if (current.ct != previous?.ct) {
          historyRowDetail = new HistoryRowDetail(field, current.ct?.toString() || '', previous?.ct?.toString() || '');
        }
        break;
      case 'CT Loc.':
        if (toString(current.ctLocation) != toString(previous?.ctLocation)) {
          historyRowDetail = new HistoryRowDetail(field, current.ctLocation || '', toString(previous?.ctLocation));
        }
        break;
      case 'Swing Wt.': {
        let currentSwingWtPrefix = current.swingWtPrefixName + current.swingWtSuffixName;
        let previousSwingWtPrefix = toString(previous?.swingWtPrefixName) + toString(previous?.swingWtSuffixName);
        if (currentSwingWtPrefix != previousSwingWtPrefix) {
          historyRowDetail = new HistoryRowDetail(field, currentSwingWtPrefix, previousSwingWtPrefix);
        }
        break;
      }
      case 'Final HW':
        //iron, utility, wedge use overallWeight
        switch (current.headTypeId) {
          case 4:
          case 5:
          case 7:
            if (current.overallWeight != previous?.overallWeight) {
              historyRowDetail = new HistoryRowDetail(field, toString(current.overallWeight), toString(previous?.overallWeight));
            }
            break;
          default:
            if (current.headWeight != previous?.headWeight) {
              historyRowDetail = new HistoryRowDetail(field, toString(current.headWeight), toString(previous?.headWeight));
            }
            break;
        }
        break;
      case 'Hot Melt 1':
        if (toString(current.ratGlue1) != toString(previous?.ratGlue1)) {
          historyRowDetail = new HistoryRowDetail(field, current.ratGlue1, previous?.ratGlue1);
        }
        break;
      case 'Hot Melt 2':
        if (toString(current.ratGlue2) != toString(previous?.ratGlue2)) {
          historyRowDetail = new HistoryRowDetail(field, current.ratGlue2, previous?.ratGlue2);
        }
        break;
      case 'Hot Melt 3':
        if (toString(current.ratGlue3) != toString(previous?.ratGlue3)) {
          historyRowDetail = new HistoryRowDetail(field, current.ratGlue3, previous?.ratGlue3);
        }
        break;
      case 'Hot Melt 4':
        if (toString(current.ratGlue4) != toString(previous?.ratGlue4)) {
          historyRowDetail = new HistoryRowDetail(field, current.ratGlue4, previous?.ratGlue4);
        }
        break;
      case 'Hot Melt 5':
        if (toString(current.ratGlue5) != toString(previous?.ratGlue5)) {
          historyRowDetail = new HistoryRowDetail(field, current.ratGlue5, previous?.ratGlue5);
        }
        break;
      case 'Hot Melt 6':
        if (toString(current.ratGlue6) != toString(previous?.ratGlue6)) {
          historyRowDetail = new HistoryRowDetail(field, current.ratGlue6, previous?.ratGlue6);
        }
        break;
      case 'Hot Melt 7':
        if (toString(current.ratGlue7) != toString(previous?.ratGlue7)) {
          historyRowDetail = new HistoryRowDetail(field, current.ratGlue7, previous?.ratGlue7);
        }
        break;
      case 'Grind Details':
        if (toString(current.grindDetails) != toString(previous?.grindDetails)) {
          historyRowDetail = new HistoryRowDetail(field, current.grindDetails, previous?.grindDetails);
        }
        break;
      case 'Shaft':
        if (toString(current.shaftName) != toString(previous?.shaftName)) {
          historyRowDetail = new HistoryRowDetail(field, current.shaftName, previous?.shaftName);
        }
        break;
      case 'Putter Shaft':
        if (toString(current.putterShaftName) != toString(previous?.putterShaftName)) {
          historyRowDetail = new HistoryRowDetail(field, current.putterShaftName, previous?.putterShaftName);
        }
        break;
      case 'Length': {
        let currentShaftLength = toString(current.shaftLengthDigit) + ' ' + toString(current.shaftLengthFraction);
        let previousShaftLength = toString(previous?.shaftLengthDigit) + ' ' + toString(previous?.shaftLengthFraction);
        if (currentShaftLength != previousShaftLength) {
          historyRowDetail = new HistoryRowDetail(field, currentShaftLength.trim(), previousShaftLength.trim());
        }
        break;
      }
      case 'Measured':
        {
          let currentMeasured = current.isShaftLengthFinished ? 'Finished' : 'Cut';
          let previousMeasured = previous?.isShaftLengthFinished ? 'Finished' : 'Cut';
          if (currentMeasured != previousMeasured) {
            historyRowDetail = new HistoryRowDetail(field, currentMeasured, previousMeasured);
          }
        }
        break;
      case 'Tipping': {
        let currentTipping = toString(current.shaftTippingDigit) + ' ' + toString(current.shaftTippingFraction);
        let previousTipping = toString(previous?.shaftTippingDigit) + ' ' + toString(previous?.shaftTippingFraction);
        if (currentTipping != previousTipping) {
          historyRowDetail = new HistoryRowDetail(field, currentTipping, previousTipping.trim());
        }
        break;
      }
      case 'Setting':
        if (toString(current.settingName) != toString(previous?.settingName)) {
          historyRowDetail = new HistoryRowDetail(field, current.settingName, toString(previous?.settingName));
        }
        break;
      case 'Sleeve':
        if (toString(current.sleeveName) != toString(previous?.sleeveName)) {
          historyRowDetail = new HistoryRowDetail(field, current.sleeveName, toString(previous?.sleeveName));
        }
        break;
      case 'Cosmetic':
        if (toString(current.shaftCosmetic) != toString(previous?.shaftCosmetic)) {
          historyRowDetail = new HistoryRowDetail(field, current.shaftCosmetic, previous?.shaftCosmetic);
        }
        break;
      case 'Grip Size':
        if (toString(current.gripSize) != toString(previous?.gripSize)) {
          historyRowDetail = new HistoryRowDetail(field, current.gripSize, toString(previous?.gripSize));
        }
        break;
      case 'Round/Rib':
        if (toString(current.rndRib) != toString(previous?.rndRib)) {
          historyRowDetail = new HistoryRowDetail(field, current.rndRib, previous?.rndRib);
        }
        break;
      case 'Logo':
        if (toString(current.logo) != toString(previous?.logo)) {
          historyRowDetail = new HistoryRowDetail(field, current.logo, previous?.logo);
        }
        break;
      case 'Grip Tape':
        if (toString(current.tape) != toString(previous?.tape)) {
          historyRowDetail = new HistoryRowDetail(field, current.tape, previous?.tape);
        }
        break;
      case 'Finish':
        if (toString(current.headFinishName) != toString(previous?.headFinishName)) {
          historyRowDetail = new HistoryRowDetail(field, current.headFinishName, toString(previous?.headFinishName));
        }
        break;
      case 'Finish Note':
        if (toString(current.headFinishNote) != toString(previous?.headFinishNote)) {
          historyRowDetail = new HistoryRowDetail(field, current.headFinishNote, toString(previous?.headFinishNote));
        }
        break;
      case 'Stamping':
        if (toString(current.stamping) != toString(previous?.stamping)) {
          historyRowDetail = new HistoryRowDetail(field, current.stamping, toString(previous?.stamping));
        }
        break;
      case 'Painting':
        if (toString(current.paintingNotes) != toString(previous?.paintingNotes)) {
          historyRowDetail = new HistoryRowDetail(field, current.paintingNotes, toString(previous?.paintingNotes));
        }
        break;
      case 'Level':
        if (toString(current.putterLevelName) != toString(previous?.putterLevelName)) {
          historyRowDetail = new HistoryRowDetail(field, current.putterLevelName, toString(previous?.putterLevelName));
        }
        break;
      case 'Type':
        if (toString(current.putterTypeName) != toString(previous?.putterTypeName)) {
          historyRowDetail = new HistoryRowDetail(field, current.putterTypeName, toString(previous?.putterTypeName));
        }
        break;
      case 'Sightline':
        if (toString(current.putterSightlineName) != toString(previous?.putterSightlineName)) {
          historyRowDetail = new HistoryRowDetail(field, current.putterSightlineName, toString(previous?.putterSightlineName));
        }
        break;
      case 'Face':
        if (toString(current.putterFaceName) != toString(previous?.putterFaceName)) {
          historyRowDetail = new HistoryRowDetail(field, current.putterFaceName, toString(previous?.putterFaceName));
        }
        break;
      case 'Neck':
        if (toString(current.putterNeckName) != toString(previous?.putterNeckName)) {
          historyRowDetail = new HistoryRowDetail(field, current.putterNeckName, toString(previous?.putterNeckName));
        }
        break;
      case 'Overall Wt.':
        if (toString(current.putterFinalHW) != toString(previous?.putterFinalHW)) {
          historyRowDetail = new HistoryRowDetail(field, current.putterFinalHW, toString(previous?.putterFinalHW));
        }
        break;
      case 'Sole Wts.':
        if (toString(current.putterWeightName) != toString(previous?.putterWeightName)) {
          historyRowDetail = new HistoryRowDetail(field, current.putterWeightName, toString(previous?.putterWeightName));
        }
        break;
      case 'Grip':
        if (current.headTypeId == 6) {
          //putter grip field is unique
          if (toString(current.putterGripName) != toString(previous?.putterGripName)) {
            historyRowDetail = new HistoryRowDetail(field, current.putterGripName, toString(previous?.putterGripName));
          }
        } else {
          //all other clubs
          if (toString(current.gripType) != toString(previous?.gripType)) {
            historyRowDetail = new HistoryRowDetail(field, current.gripType, toString(previous?.gripType));
          }
        }
        break;
      case 'Ball':
        if (toString(current.bsgBallName) != toString(previous?.bsgBallName)) {
          historyRowDetail = new HistoryRowDetail(field, current.bsgBallName, toString(previous?.bsgBallName));
        }
        break;
      case 'Glove':
        if (toString(current.bsgGloveName) != toString(previous?.bsgGloveName)) {
          historyRowDetail = new HistoryRowDetail(field, current.bsgGloveName, toString(previous?.bsgGloveName));
        }
        break;
      case 'Glove Note':
        if (toString(current.bsgGloveNote) != toString(previous?.bsgGloveNote)) {
          historyRowDetail = new HistoryRowDetail(field, current.bsgGloveNote, toString(previous?.bsgGloveNote));
        }
        break;
      case 'Headwear':
        if (toString(current.bsgHeadwearName) != toString(previous?.bsgHeadwearName)) {
          historyRowDetail = new HistoryRowDetail(field, current.bsgHeadwearName, toString(previous?.bsgHeadwearName));
        }
        break;
      case 'Shoe':
        if (toString(current.bsgShoeName) != toString(previous?.bsgShoeName)) {
          historyRowDetail = new HistoryRowDetail(field, current.bsgShoeName, toString(previous?.bsgShoeName));
        }
        break;
      case 'Size':
        if (toString(current.bsgShoeSizeName) != toString(previous?.bsgShoeSizeName)) {
          historyRowDetail = new HistoryRowDetail(field, current.bsgShoeSizeName, toString(previous?.bsgShoeSizeName));
        }
        break;
      case 'Width':
        if (toString(current.bsgShoeWidthName) != toString(previous?.bsgShoeWidthName)) {
          historyRowDetail = new HistoryRowDetail(field, current.bsgShoeWidthName, toString(previous?.bsgShoeWidthName));
        }
        break;
      case 'Golf Bag':
        if (toString(current.golfBagName) != toString(previous?.golfBagName)) {
          historyRowDetail = new HistoryRowDetail(field, current.golfBagName, toString(previous?.golfBagName));
        }
        break;
      case 'Glove Size':
        if (toString(current.bsgGloveSizeName) != toString(previous?.bsgGloveSizeName)) {
          historyRowDetail = new HistoryRowDetail(field, current.bsgGloveSizeName, toString(previous?.bsgGloveSizeName));
        }
        break;
      case 'Name on Bag':
        if (toString(current.nameOnBag) != toString(previous?.nameOnBag)) {
          historyRowDetail = new HistoryRowDetail(field, current.nameOnBag, toString(previous?.nameOnBag));
        }
        break;
      case 'Bag Logo 1':
        if (toString(current.golfBagLogo1) != toString(previous?.golfBagLogo1)) {
          historyRowDetail = new HistoryRowDetail(field, current.golfBagLogo1, toString(previous?.golfBagLogo1));
        }
        break;
      case 'Bag Logo 2':
        if (toString(current.golfBagLogo2) != toString(previous?.golfBagLogo2)) {
          historyRowDetail = new HistoryRowDetail(field, current.golfBagLogo2, toString(previous?.golfBagLogo2));
        }
        break;
      case 'Bag Logo 3':
        if (toString(current.golfBagLogo3) != toString(previous?.golfBagLogo3)) {
          historyRowDetail = new HistoryRowDetail(field, current.golfBagLogo3, toString(previous?.golfBagLogo3));
        }
        break;
      case 'Bag Note':
        if (toString(current.golfBagNotes) != toString(previous?.golfBagNotes)) {
          historyRowDetail = new HistoryRowDetail(field, current.golfBagNotes, toString(previous?.golfBagNotes));
        }
        break;
      case 'Ball Note':
        if (toString(current.bsgBallNote) != toString(previous?.bsgBallNote)) {
          historyRowDetail = new HistoryRowDetail(field, current.bsgBallNote, toString(previous?.bsgBallNote));
        }
        break;
      case 'Headwear Note':
        if (toString(current.bsgHeadwearNote) != toString(previous?.bsgHeadwearNote)) {
          historyRowDetail = new HistoryRowDetail(field, current.bsgHeadwearNote, toString(previous?.bsgHeadwearNote));
        }
        break;
      case 'Notes':
        if (toString(current.notes) != toString(previous?.notes)) {
          historyRowDetail = new HistoryRowDetail(field, current.notes, toString(previous?.notes));
        }
        break;
    }
    //if a diff was found, save it to the collection
    if (historyRowDetail) {
      //special case: If this was the first record in the history, then the 'previous' field will always be null. This allows it to be hidden on the modal
      if (previous == null) {
        historyRowDetail.previous = null;
      }
      historyRowDetails.push(historyRowDetail);
    }
  });

  //all fields have been checked for diff. Should we save it?
  if (historyRowDetails.length > 0) {
    historyRow = new HistoryRow(current.modifyUserName, formatDate(current.modifyDate), historyRowDetails);
  }

  return historyRow;
};

const toString = (s: any) => {
  let result = '';
  try {
    //need a toString() for when numbers are passed in for conversion
    result = s.toString().trim();
    // eslint-disable-next-line no-empty
  } catch {}

  //special case for boolean - make first letter uppercase for display purposes
  if (result.toLocaleLowerCase() == 'true') {
    result = 'Yes';
  }
  if (result.toLocaleLowerCase() == 'false') {
    result = 'No';
  }

  return result;
};

const formatDate = (date: Date) => {
  let d = dayjs(date);
  let d2 = d.format('MM-DD-YYYY');
  return d2;
};
